import React from 'react';
import ReactDOM from 'react-dom';
import SplitTter from './SplitTter';

ReactDOM.render(
  <React.StrictMode>
    <SplitTter />
  </React.StrictMode>,
  document.getElementById('root')
);
